import { useRef } from 'react';
import { FPS } from '../../constants';
export function useFramesToDownload(currentFrame: number, imageLoadStatus: boolean[]) {
  let framesInSecond = Math.floor(60 * (60 / FPS));
  const lastFrameIndexThatCanBeDownloadedRef = useRef(framesInSecond);
  if (currentFrame > imageLoadStatus.length) {
    return currentFrame;
  }

  // eslint-disable-next-line react-hooks/refs
  if (currentFrame > lastFrameIndexThatCanBeDownloadedRef.current) {
    // eslint-disable-next-line react-hooks/refs
    lastFrameIndexThatCanBeDownloadedRef.current = currentFrame;
  }

  // Checking if all frames all downloaded in current range.
  let allFramesDownloadedInRange = true;
  for (let index = currentFrame;
  // eslint-disable-next-line react-hooks/refs
  index < lastFrameIndexThatCanBeDownloadedRef.current - 1; index++) {
    if (!imageLoadStatus[index]) {
      allFramesDownloadedInRange = false;
      break;
    }
  }

  // If all frame are downloaded update state
  if (allFramesDownloadedInRange) {
    // eslint-disable-next-line react-hooks/refs
    lastFrameIndexThatCanBeDownloadedRef.current += framesInSecond;
  }

  // eslint-disable-next-line react-hooks/refs
  return lastFrameIndexThatCanBeDownloadedRef.current;
}